
import api from "../utils/axiosInstance";


export const getAddress = async (data) => {
    try {
        const response = await api.post(`/wallet/get-address`, data);
        return response;
    } catch (error) {
        return error;
    }
};

export const getUserWalletSingle = async (data) => {
    try {
        const response = await api.post(`/wallet/get-sinlge-wallet`, data);
        return response;
    } catch (error) {
        return error;
    }
};

export const getUserWalletDetail = async (data) => {
    try {
        const response = await api.post(`/wallet/get-wallet-detail`, data);
        return response;
    } catch (error) {
        return error;
    }
};

export const withdrawPreCheck = async (data) => {
    try {
        const response = await api.post(`/withdraw/precheck`, data);
        return response;
    } catch (error) {
        return error;
    }
};

export const GetWithdrawAddress = async (data) => {
    try {
        const response = await api.post(`/withdraw/get-history-address`, data);
        return response;
    } catch (error) {
        return error;
    }
};

export const GetDepositHisList = async (data) => {
    try {
        const response = await api.post(`/deposit/get-deposit-list`, data);
        return response;
    } catch (error) {
        return error;
    }
};

export const GetWithdrawHisList = async (data) => {
    try {
        const response = await api.post(`/withdraw/get-withdraw-history`, data);
        return response;
    } catch (error) {
        return error;
    }
};

export const GetBalanceReport = async (data) => {
    try {
        const response = await api.post(`/wallet/balance-report`, data);
        return response;
    } catch (error) {
        return error;
    }
};

export const GetWalletTransactions = async (data) => {
    try {
        const response = await api.post(`/wallet/get-transaction-history`, data);
        return response;
    } catch (error) {
        return error;
    }
};

export const GetWalletAssetDetails = async (data) => {
    try {
        const response = await api.post(`/wallet/get-asset-details`, data);
        return response;
    } catch (error) {
        return error;
    }
};

export const createDeposit = async (data) => {
    try {
        const response = await api.post(`/wallet/create-deposit`, data);
        return response;
    } catch (error) {
        return error;
    }
};